export const isInFlutterWrapper = (): boolean =>
  !!window['flutter_inappwebview'];

export const getIdTokenFromFlutterWebViewEvent = async (): Promise<string> => {
  return await window['flutter_inappwebview'].callHandler(
    'request_aad_id_token'
  );
};

export const getAccessTokenFromFlutterWebViewEvent =
  async (): Promise<string> => {
    return await window['flutter_inappwebview'].callHandler(
      'request_aad_token'
    );
  };

export const logoutFromFlutterWebViewEvent = async (): Promise<string> => {
  return await window['flutter_inappwebview'].callHandler('request_aad_logout');
};

export const getScreenshotBase64FromFlutterEvent =
  async (): Promise<string> => {
    // request_screenshot_image -> base64
    // request_screenshot_share -> share

    return await window['flutter_inappwebview'].callHandler(
      'request_screenshot_image'
    );
  };
